import { render } from "./BlockIcon.vue?vue&type=template&id=a312a47a&scoped=true"
import script from "./BlockIcon.vue?vue&type=script&lang=js"
export * from "./BlockIcon.vue?vue&type=script&lang=js"

import "./BlockIcon.vue?vue&type=style&index=0&id=a312a47a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a312a47a"]])

export default __exports__